import { getDoc } from '../../lib/docsRegistry'
import DocsLayout from '../../components/docs/DocsLayout'
import DocContent from '../../components/docs/DocContent'
import TranslationBanner from '../../components/docs/TranslationBanner'

export default function Show({ locale, section, page }) {
  const doc = getDoc(locale, section, page)

  if (!doc) {
    return (
      <div className="min-h-screen bg-zinc-900 text-zinc-100 flex flex-col items-center justify-center gap-4">
        <p className="text-zinc-400 font-mono text-sm">Page not found</p>
        <a href={`/docs/${locale}`} className="text-emerald-400 font-mono text-sm hover:text-emerald-300">
          ← Back to docs
        </a>
      </div>
    )
  }

  const { content, fallback } = doc

  return (
    <DocsLayout locale={locale} section={section} page={page}>
      <TranslationBanner show={fallback === true} locale={locale} />
      <DocContent content={content} />
    </DocsLayout>
  )
}
